var MenuHoverEvent = /** @class */ (function () {
    function MenuHoverEvent(buttonIsHovered, panelIsHovered, searchBarIsFocused, index) {
        this.buttonIsHovered = buttonIsHovered;
        this.panelIsHovered = panelIsHovered;
        this.searchBarIsFocused = searchBarIsFocused;
        this.index = index;
    }
    return MenuHoverEvent;
}());
export { MenuHoverEvent };
